import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tooltip } from 'antd'
import { EditOutlined } from '@ant-design/icons'

import { toPath } from '../../routes'

function PatientEntry({patient: {id, firstName, lastName}, name = ''}) {
  return <>
    <Link
      to={toPath.patients.patient({ id })}
      style={{ whiteSpace: 'nowrap', marginRight: 5 }}
    >
      <Tooltip title="View Patient">
        {name ||  `${lastName}, ${firstName}`}
      </Tooltip>
    </Link>
    <Link
      to={toPath.patients.patient.edit({ id })}
      aria-label="Edit Patient"
    >
      <Tooltip title="Edit Patient">
        <EditOutlined />
      </Tooltip>
    </Link>
  </>
}

PatientEntry.propTypes = {
  patient: PropTypes.shape({
    id: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired
  }).isRequired,
  name: PropTypes.string,
}

export default PatientEntry
